const extrairConfig = (origem) => origem?.response?.config ?? origem?.config ?? origem

export default class ConfigRequisicaoUtils {
	static montar(...chaves) {
		return chaves.reduce((config, { chave, valor }) => ({ ...config, [chave]: valor }), {})
	}

	static isAtiva(origem, { chave } = {}) {
		return !!extrairConfig(origem)?.[chave]
	}
}
